import React,{useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';

import CommonTooltip from '../../../../../../../../../component/common/CommonTooltip';


const ProductListTable = (props) => {
   
    const {
        product_name , 
        selected_feature , 
        product_synonyms,
        index
    } = props;

    // -------------- set product synonyms ------------ //
    let productSynonyms = '';
    if(product_synonyms.length > 0){
        productSynonyms = product_synonyms.map((synonyms) =>
            <span className="badge badge-light-dark fs-7 fw-bold me-2 text-gray-600"  key={uuidv4()}>
                <span className="text-gray-600 fw-bold fs-6">
                    {synonyms.value}
                </span>
            </span>
        ) 
    }


    const productDeleteOnClick = async (index) => {
        const productDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (productDeleteSwal.isConfirmed) {
            props.productDeleteOnClick(index)
        }
    }

    const productDragStart = (e) => {
        e.dataTransfer.setData('text/plain', index);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'), 10);
        props.onDragDrop(draggedIndex, index);
    };
    

    return (
        <>
            <tr
                draggable
                onDragStart={productDragStart}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
                style={{
                    cursor: "move",
                }}
            >
                <td 
                    className=""
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    <div className="text-gray-800 fw-bold mb-1 fs-6">
                        {product_name}
                    </div>
                </td>
                <td 
                    className="pe-0" 
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                   {productSynonyms}
                </td>
                <td 
                    className="d-flex float-end" 
                >
                    <div
                        className='cursor-pointer me-3' 
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Edit"
                        onClick={(e) => { e.preventDefault(); props.productUpdateOnClick(index);}}
                    >
                        <FontAwesomeIcon icon={faPen} className='text-primary fs-3' />
                    </div>
                    <div
                        className='cursor-pointer'
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Delete"
                        onClick={(e) => { e.preventDefault(); productDeleteOnClick(index); }} 
                    >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
            <CommonTooltip
                id="common_tooltip"
                style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                place="top"
                float={true}
            />
        </>
    )
}

const ProductList = (props) => {

    const [productDataList, setProductDataList] = useState([]);
    useEffect(() => {
        if (props.productDataList) {
            setProductDataList(props.productDataList);
        }
    }, [props.productDataList]);

    const productDragAndDropHandler = (draggedIndex, targetIndex) => {
        const updatedList = [...productDataList];
        const [draggedItem] = updatedList.splice(draggedIndex, 1);
        updatedList.splice(targetIndex, 0, draggedItem);
        updatedList.forEach((item, newIndex) => {
            item.index = newIndex;
        });
        setProductDataList(updatedList);
        props.productListOnDrop(updatedList)
    };

    var productData = '';
    if(productDataList.length > 0){
        productData = productDataList.map((product, i) =>
            <ProductListTable
                key={uuidv4()}
                product_name = {product.product_name}
                product_synonyms = {product.product_synonyms}
                index={i}
                selected_feature = {product.selected_feature}
                productUpdateOnClick={props.productUpdateOnClick}
                productDeleteOnClick={props.productDeleteOnClick}
                onDragDrop={productDragAndDropHandler}
            />
        ) 
    }
    return (
        <>
            {productDataList.length > 0 &&
                <>
                    <div className="separator border-gray-300 my-6 mb-0"></div>
                    <div className='col-md-12'>
                        <div className="table-responsive">
                            <table className="table table-row-dashed align-middle gs-0 gy-4">
                                <thead>
                                    <tr className="fs-7 fw-bold border-0 text-gray-400">
                                        <th className="" >Product Name</th>
                                        <th className="" >Product Synonyms</th>
                                        {/* <th className="" >Feature Name</th> */}
                                        <th className="" ></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productData}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default ProductList